import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedPromoID: null, // Начальное значение ID
};

const selectedPromoIDSlice = createSlice({
    name: "selectedPromoID",
    initialState,
    reducers: {
        setSelectedPromoID: (state, action) => {
            state.selectedPromoID = action.payload; // Устанавливаем ID
        },
        clearSelectedPromoID: (state) => {
            state.selectedPromoID = null; // Сбрасываем ID
        },
    },
});

export const { setSelectedPromoID, clearSelectedPromoID } = selectedPromoIDSlice.actions;
export default selectedPromoIDSlice.reducer;
